<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ taskItem.Title }}</h1>
        <div v-if="taskListTable.length > 0">
            <div v-if="infoTaskError.length > 0">
                <b-button v-b-toggle.collapse-1 variant="outline-info">{{ $t('label.numberOfTaskNotFound') }} ({{
                    infoTaskError.length }})</b-button>
                <b-collapse id="collapse-1" class="mt-2">
                    <b-alert show variant="info" class="mt-2">
                        <strong>{{ $t('info.taskNotFound') }}</strong>
                        <ul class="mt-2">
                            <li v-for="group in infoTaskError" v-bind:key="group.Id">
                                {{ group.GroupName }}
                            </li>
                        </ul>
                    </b-alert>
                </b-collapse>
            </div>

            <b-row class="pt-2">
                <b-col sm="4" class="mt-2">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
                    <b-button variant="link" @click="resetTable()">{{
                        $t("action.reset")
                    }}</b-button>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <div>{{ $t("label.tablesize") }} {{ rows }}</div>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col class="lgTable">
                    <b-table id="taskRecurrenceListTable" stacked="lg" bordered :fields="myfields" :items="items"
                        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :per-page="perPage"
                        :current-page="currentPage">
                        <!-- 
                        <template v-slot:cell(details)="row">
                            <b-button size="sm" @click="row.toggleDetails">
                                {{ row.detailsShowing ? $t("action.hide") : $t("action.show") }}
                            </b-button>
                        </template>
                        -->
                    </b-table>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col sm="6" class="mt-2">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="taskRecurrenceListTable"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
    mixins: [globalF],
    props: ["task"],
    data() {
        return {
            success: false,
            error: "",
            spinner: false,
            taskList: [],
            taskListTable: [],
            rawData: [],
            teamsGroup: [],
            teamBuildings: [],
            buildings: [],
            building: null,
            sortBy: "buildingName",
            sortDesc: false,
            perPage: 10,
            currentPage: 1,
            search: "",
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            teamSelect: null,
            existingTeamForBuilding: false,
            newGroupName: "",
            teamPlan: null,
            teamBucket: null,
            memberOf: [],
            rowItem: null,
            infoTaskError: [],
            taskEvent: []
        };
    },
    validations() { },
    mounted() {
        this.getTeamBuildingTaskList();
    },
    watch: {},
    computed: {
        user: function () {
            return this.$store.getters.getUser;
        },
        taskItem: function () {
            return this.$store.getters.getTaskSelected
        },
        url: function () {
            return this.getUrl();
        },
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.taskListTable;
            let search = this.search.toLowerCase();

            return mydatalist.filter((p) => {
                let buildingName = p.buildingName ? p.buildingName : "";
                let groupName = p.groupName ? p.groupName : "";
                let createdDateTime = p.createdDateTime ? p.createdDateTime : "";
                let dueDateTime = p.dueDateTime ? p.dueDateTime : "";
                let completedDateTime = p.completedDateTime ? p.completedDateTime : "";

                return (
                    buildingName.toString().toLowerCase().includes(search) ||
                    groupName.toString().toLowerCase().includes(search) ||
                    createdDateTime.toLowerCase().includes(search) ||
                    dueDateTime.toLowerCase().includes(search) ||
                    completedDateTime.toLowerCase().includes(search)
                );
            });
        },
        myfields: function () {
            return [
                {
                    key: "buildingName",
                    sortable: true,
                    label: this.$t("label.buildingName"),
                },
                {
                    key: "createdDateTime",
                    sortable: true,
                    label: this.$t("label.createdDateTime"),
                    formatter: (value) => {
                        return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
                    },
                },
                {
                    key: "dueDateTime",
                    sortable: true,
                    label: this.$t("label.dueDateTime"),
                    formatter: (value) => {
                        return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
                    },
                },
                {
                    key: "completedDateTime",
                    sortable: true,
                    label: this.$t("label.completedDateTime"),
                    formatter: (value) => {
                        return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
                    },
                },
                {
                    key: "completedByUser",
                    sortable: true,
                    label: this.$t("label.completedBy"),
                    formatter: (value) => {
                        return this.getDisplayName(value);
                    },
                },
                {
                    key: "details",
                    label: this.$t("label.details"),
                    sortable: false,
                },
            ];
        },
    },
    methods: {
        getGraphUser(idUser) {
            this.spinner = true;
            let token = this.getGlobalData("accessToken");
            let graphEndpoint = `https://graph.microsoft.com/v1.0/users/${idUser}`;
            axios
                .get(graphEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    return response.data.displayName;
                })
                .catch(() => {
                    this.info = this.$t("info.errorlogin");
                    this.spinner = false;
                    this.signInBtn = true;
                });
        },
        openModal: function (id, value) {
            this.rowItem = value;
            this.$bvModal.show(id);
        },
        getTeamBuildingTaskList() {
            if (this.task) {
                this.spinner = true;
                let urls = this.$store.getters.getUrlsList;
                let url = urls[process.env.VUE_APP_WHERE].json;
                this.taskListTable = [];

                axios
                    .post(
                        url,
                        { request: "getTaskEventGroupBuildingByIdTaskEventAndIdGroupBuilding", idTaskEvent: this.task.IdTaskEvent, 
                        idGroupBuilding: this.task.IdGroupBuilding },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        this.teamBuildings = response.data.teamBuildings;
                        this.buildings = response.data.buildings;
                        this.taskEvent = response.data.taskEvent;
                        this.setPlannerTasksList(response.data.taskEvent);
                        //this.getTaskBuilding();
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            }
        },
        resetTable: function () {
            this.search = "";
        },
        /*OnTaskClick: function () {
          this.taskListTable = [];
          this.infoTaskError = [];
          if (this.task) {
            this.getTaskBuilding();
          }
        },*/
        getTaskBuilding: function () {
            let task = this.$store.getters.getTaskSelected
            this.error = "";
            this.spinner = true;
            let obj = {
                request: "getTaskEventGroupBuilding",
                idTaskEvent: task.Id
            };
            axios
                .post(this.url, obj, {
                    headers: { "Content-Type": "application/json" },
                })
                .then((response) => {
                    this.setPlannerTasksList(response.data);
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        getAllTasksByPlanId() {
            //graphEndPoint
            let token = this.getGlobalData("accessToken");
            let task = this.$store.getters.getTaskSelected;
            let planId = task.planId;
            let graphEndPoint = `https://graph.microsoft.com/v1.0/planner/plans/${planId}/tasks`;

            axios
                .get(graphEndPoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                })
                .then(() => {
                    this.spinner = false;
                })
                .catch(() => {
                    this.error = this.$t("info.errorgeneric");
                    this.spinner = false;
                });
        },
        setPlannerTasksList(taskBuilding) {
            let token = this.getGlobalData("accessToken");

            let request = [];

            for (let i = 0; i < taskBuilding.length; i++) {
                let IdTaskGraph = taskBuilding[i].IdTaskMicrosoft;

                //let graphEndPoint = `https://graph.microsoft.com/v1.0/planner/tasks/${IdTaskGraph}`;
                let graphEndPoint = `https://graph.microsoft.com/beta/planner/tasks/${IdTaskGraph}`;

                request.push(this.getPlannerTasks(token, graphEndPoint));
            }

            Promise.allSettled(request).then((results) => {
                this.spinner = false;
                let successList = results.filter((r) => r.status === "fulfilled");
                if (successList.length > 0) {
                    this.setTaskBuilding(successList, taskBuilding);
                }

                let errorList = results.filter((r) => r.status === "rejected");
                if (errorList.length > 0) {
                    this.getInfoTaskError(successList, taskBuilding);
                    this.logError(errorList);
                }
            });
        },
        getInfoTaskError(successList, taskBuilding) {
            let teamBuildings = this.teamBuildings;

            let taskError = taskBuilding.filter(t => {
                let found = successList.find((s) => t.IdTaskMicrosoft === s.value.data.id)
                if (!found) {
                    return t;
                }
            });

            this.infoTaskError = teamBuildings.filter(t => {
                let found = taskError.find((s) => t.Id === s.IdGroupBuilding)
                if (found) {
                    return t;
                }
            })
        },
        getAssignements(taskList) {
            let keyList = [];

            let assignments = taskList.assignments;

            if (assignments) {
                for (const [key] of Object.entries(assignments)) {
                    keyList.push(key);
                }
            }

            return keyList;
        },
        getPlannerTasks(token, graphEndpoint) {
            return axios.get(graphEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
        },
        setTaskBuilding(successList, taskBuildings) {
            this.spinner = false;

            let teamBuildings = this.teamBuildings;
            let completedByUserList = [];

            let taskList = successList.map((s) => {
                let taskList = s.value.data;
                let taskBuilding = taskBuildings.find(
                    (t) => t.IdTaskMicrosoft === taskList.id
                );

                let teamBuilding = teamBuildings.find(
                    (t) => t.Id === taskBuilding.IdGroupBuilding
                );

                taskList.IdTaskEvent = taskBuilding.IdTaskEvent;

                taskList.groupName = teamBuilding.GroupName;
                taskList.groupId = teamBuilding.GroupId;

                let building = this.buildings.find(
                    (b) => b.Id === teamBuilding.IdBuilding
                );

                taskList.buildingName = building ? building.NOMDIV : "undefined";

                taskList._cellVariants = this.setCellVariants(taskList);

                taskList.assigmentsKey = this.getAssignements(taskList);
                if (taskList.completedBy) {
                    completedByUserList.push(taskList.completedBy.user.id);
                }
                taskList.completedByUser = taskList.completedBy
                    ? taskList.completedBy.user.id
                    : "";

                return taskList;
            });

            if (completedByUserList.length > 0) {
                this.getUsers(completedByUserList, taskList);
            } else {
                this.taskListTable = taskList;
            }
        },
        getUsers(completedByUserList, taskList) {
            let token = this.getGlobalData("accessToken");

            let request = [];

            for (let i = 0; i < completedByUserList.length; i++) {
                let userId = completedByUserList[i];
                request.push(this.getUserById(token, userId));
            }

            Promise.allSettled(request).then((results) => {
                this.spinner = false;
                let successList = results.filter((r) => r.status === "fulfilled");
                if (successList.length > 0) {
                    this.memberOf = successList.map((r) => r.value.data);
                    this.taskListTable = taskList;
                }

                let errorList = results.filter((r) => r.status === "rejected");
                if (errorList.length > 0) {
                    this.logError(errorList);
                }
            });
        },
        getUserById(token, idUser) {
            let graphEndpoint = `https://graph.microsoft.com/v1.0/users/${idUser}`;
            return axios.get(graphEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
        },
        getDisplayName(idUser) {
            let memberOf = this.memberOf;
            let displayName = "";
            if (memberOf.length > 0) {
                let member = memberOf.find((m) => m.id === idUser);
                if (member) {
                    displayName = member.displayName;
                }
            }
            return displayName;
        },
        setCellVariants(taskList) {
            let now = moment().format("YYYY-MM-DD HH:mm:ss");
            let dueDateTime = taskList.dueDateTime
                ? moment(taskList.dueDateTime).format("YYYY-MM-DD HH:mm:ss")
                : null;
            let completedDateTime = taskList.completedDateTime
                ? moment(taskList.completedDateTime).format("YYYY-MM-DD HH:mm:ss")
                : null;

            let taskStatusObj = { dueDateTime: "" };
            if (completedDateTime) {
                taskStatusObj = { completedDateTime: "success" };
            } else if (dueDateTime < now) {
                taskStatusObj = { dueDateTime: "danger" };
            } else if (dueDateTime > now) {
                taskStatusObj = { dueDateTime: "warning" };
            } else {
                taskStatusObj = { dueDateTime: "" };
            }

            return taskStatusObj;
        },
        logError(errorList) {
            let obj = {
                request: "logError",
                jobName: "TaskEventList",
                errorList: errorList,
            };
            axios
                .post(this.url, obj, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.spinner = false;
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        setNextPage(page) {
            this.$emit('changePage', page);
        }
    },
    components: {},
};
</script>